import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../ui/authorizedUiElement";
import { vsServiceName as RoleDetailTabsServiceName } from "./service";

export class RoleDetailComponentController {
  static $inject = [RoleDetailTabsServiceName];

  constructor(
    private readonly roleDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}
}
